import React, { memo, useMemo } from 'react';
import { createUseStyles, Text, useTheme } from '@Sage/hoi-poi-ui';

import styles from './styles';

const useStyles = createUseStyles(styles, 'Kpi');

const Kpi = memo(({ data }) => {
    const classes = useStyles();
    const theme = useTheme();

    const renderBoxes = useMemo(() => {
        if (!data?.data?.length) return null;
        return data.data.map((current, index) => {
            return (
                <div key={index} className={classes.boxContainer}>
                    <div className={classes.boxValue}>
                        <Text type="h3">{current.value}</Text>
                    </div>
                    <div className={classes.boxLabel}>
                        <Text type="subtitle1" color={theme.colors.grey[500]}>
                            {current.label}
                        </Text>
                        {current.labelBreakdown && (
                            <Text type="subtitle" color={theme.colors.grey[500]}>
                                {current.labelBreakdown}
                            </Text>
                        )}
                    </div>
                </div>
            );
        });
    }, [data, classes, theme]);

    return <div className={classes.root}>{renderBoxes}</div>;
});

export default Kpi;
